/** Liquid-glass surfaces for listing management modals (iOS-style). */
import { shapeSection } from '../../../theme/shape';

export const LISTING_MODAL_SECTION_SX = {
  borderRadius: shapeSection,
  border: '1px solid rgba(255,255,255,0.72)',
  bgcolor: 'rgba(255,255,255,0.62)',
  backdropFilter: 'saturate(180%) blur(20px)',
  WebkitBackdropFilter: 'saturate(180%) blur(20px)',
  boxShadow: [
    '0 0 0 1px rgba(0,0,0,0.04)',
    '0 8px 32px rgba(0,0,0,0.06)',
    'inset 0 1px 0 rgba(255,255,255,0.85)',
  ].join(', '),
  p: { xs: 1.75, sm: 2 },
  '@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))': {
    bgcolor: 'rgba(255,255,255,0.96)',
    backdropFilter: 'none',
    WebkitBackdropFilter: 'none',
  },
};

export const LISTING_MODAL_HELPER_SX = {
  fontSize: '0.72rem',
  color: 'rgba(0,0,0,0.45)',
  lineHeight: 1.45,
  mt: 1.25,
};

export const LISTING_MODAL_BODY_SX = {
  fontSize: '0.8125rem',
  color: 'rgba(0,0,0,0.55)',
  lineHeight: 1.5,
};

export const LISTING_MODAL_TITLE_BAR_SX = {
  fontWeight: 600,
  letterSpacing: '-0.02em',
  display: 'grid',
  gridTemplateColumns: '44px 1fr 44px',
  alignItems: 'center',
  gap: 0.5,
  px: { xs: 2, sm: 2.5 },
  pb: { xs: 1.25, sm: 1.5 },
  pt: {
    xs: 'max(env(safe-area-inset-top, 0px) + 12px, 20px)',
    sm: 2.5,
  },
  borderBottom: '1px solid rgba(0,0,0,0.06)',
  flexShrink: 0,
};

const LISTING_MODAL_CIRCLE_BTN_BASE = {
  width: 44,
  height: 44,
  minWidth: 44,
  minHeight: 44,
  borderRadius: '50% !important',
  p: 0,
  flexShrink: 0,
};

export const LISTING_MODAL_ICON_BTN_SX = {
  ...LISTING_MODAL_CIRCLE_BTN_BASE,
  color: 'rgba(0,0,0,0.45)',
  '&:disabled': { opacity: 0.35 },
};

export const LISTING_MODAL_SAVE_BTN_SX = {
  ...LISTING_MODAL_CIRCLE_BTN_BASE,
  color: 'rgba(0,103,102,0.92)',
  bgcolor: 'rgba(0,103,102,0.08)',
  '&:hover': { bgcolor: 'rgba(0,103,102,0.14)' },
  '&:disabled': { opacity: 0.35, bgcolor: 'rgba(0,103,102,0.06)' },
};

export const LISTING_MODAL_SAVE_BTN_DESTRUCTIVE_SX = {
  ...LISTING_MODAL_CIRCLE_BTN_BASE,
  color: 'rgba(185,28,28,0.92)',
  bgcolor: 'rgba(185,28,28,0.08)',
  '&:hover': { bgcolor: 'rgba(185,28,28,0.14)' },
  '&:disabled': { opacity: 0.35, bgcolor: 'rgba(185,28,28,0.06)' },
};

export const LISTING_MODAL_SYNCED_BADGE_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 0.85,
  py: 0.2,
  borderRadius: '999px',
  fontSize: '0.62rem',
  fontWeight: 600,
  letterSpacing: 0.25,
  textTransform: 'uppercase',
  color: 'rgba(0,103,102,0.9)',
  bgcolor: 'rgba(0,103,102,0.1)',
  border: '1px solid rgba(0,103,102,0.18)',
  ml: 0.75,
  verticalAlign: 'middle',
};
